import * as React from 'react';
import {Margins, Scales} from '../../types';
import {Label} from './Label';

interface QuadrantProps {
  area: {x: number; x2: number; y: number; y2: number};
  scales: Scales;
  margins: Margins;
  fill: string;
  label?: string;
}

/**
 * Draw a rectangular quadrant on the grid, given the area (scaled x/y), chart defaults,
 * fill color and optional label.
 */
export class Quadrant extends React.Component<QuadrantProps> {
  render() {
    const {scales, area, fill, label} = this.props;
    const {xScale, yScale} = scales;

    const x = xScale(area.x)!;
    const x2 = xScale(area.x2)!;
    const y = yScale(100 - area.y)!;
    const y2 = yScale(100 - area.y2)!;

    const height = y2 - y;
    const width = x2 - x;

    const labelLoc = {x: x + width * 0.95, y: y + height * 0.9};

    return (
      <g>
        <rect x={x} y={y} height={height} width={width} fill={fill} />
        {label && <Label label={label} location={labelLoc} />}
      </g>
    );
  }
}
